module.exports = __webpack_public_path__ + "static/img/vyvazovaci_ventil_zavitovy.7808977.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vyvazovaci_ventil_zavitovy.png
// module id = g9LL
// module chunks = 1